import { useEffect, useState } from "react";
import { APK } from "@/data/installApp";
import { fetchLatestApk, installedApkCode } from "@/lib/apkVersion";

// Latest published APK metadata + the versionCode installed on this device (null when not running from the APK).
export function useLatestApk() {
  const [latest, setLatest] = useState(APK);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let alive = true;
    fetchLatestApk().then((j) => { if (alive) { setLatest(j); setLoaded(true); } });
    return () => { alive = false; };
  }, []);
  const installedCode = installedApkCode();
  const updateAvailable = loaded && installedCode !== null && latest.versionCode > installedCode;
  return { latest, loaded, installedCode, updateAvailable };
}
